import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, OnDestroy, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatRowDef, MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslocoModule } from "@ngneat/transloco";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { SystemServicesService } from "./system-services.service";
import { FormSystemServicesComponent } from "./form-system-services/form-system-services.component";
import { FormSystemConfigurationComponent } from "./form-system-configuration/form-system-configuration.component";
import { MiddlewareServiceAttributes } from "@albatrosdeveloper/ave-models-package";
import { IPaginationResult } from "app/common/interfaces";
import { DialogModule } from "@angular/cdk/dialog";
import { Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";

@Component({
  selector: 'app-system-services',
  standalone: true,
  templateUrl: './system-services.component.html',
  styleUrl: './system-services.component.scss',
  imports: [
    TranslocoModule,
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    DialogModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})

export class SystemServicesComponent implements AfterViewInit, OnDestroy {
  displayedColumns: string[] = ["nro", "code","type", "module","apiUrl","frecuency","actions"];

  dataSource = new MatTableDataSource<MiddlewareServiceAttributes>([]);

  totalItems = 0;
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof MiddlewareServiceAttributes = "createdAt";
  sortDirection: "ASC" | "DESC" = "ASC";

  frecuencyList: { fecuency: string; value: string }[] = [
    { fecuency: 'Diario', value: 'D'},
    { fecuency: 'Semanal', value: 'S'},
    { fecuency: 'Quincenal', value: 'Q'},
    { fecuency: 'Mensual', value: 'M'},
    { fecuency: 'Anual', value: 'A'},
    { fecuency: 'Cada x horas', value: 'NHOURS'},
    { fecuency: 'Cada x minutos', value: 'NMINUTES'}
  ];
  
  @ViewChild("syncDialog") syncDialog!: TemplateRef<any>;
  
  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: [] = [];
    form: FormGroup;
  
  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private readonly systemservicesService: SystemServicesService,
    private readonly searchService: SearchService,
    private fb: FormBuilder,
  ) { 
    this.form = this.fb.group({
      companyId: []
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.findAllWithCount();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.findAllWithCount()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.findAllWithCount()
      });
  }

  findAllWithCount(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    this.systemservicesService.findAllWithCount(options,
      this.form.get("companyId").get,
      this.selectedStatuses
    ).subscribe({
      next: (res:IPaginationResult<MiddlewareServiceAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener registros","Cerrar",{ duration: 5000});
      },
    });
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.findAllWithCount();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = (event.pageIndex + 1);
    this.findAllWithCount(); 
  }

  getFrecuencyName(value: string){
    const result = this.frecuencyList.find(item => item.value === value);
    return result?.fecuency; 
  }

  openCreateModal(): void {
    
  }

  clearFilters(): void {
    this.selectedStatuses = [];
    this.findAllWithCount();
  }

  openEditModal(element: any): void {
    const dialogRef = this.dialog.open(FormSystemServicesComponent, {
      //panelClass: ".form-modal-interlocutor",
      data: element,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.findAllWithCount();
      }
    });
  }

  openConfigurationModal(): void {
    const dialogRef = this.dialog.open(FormSystemConfigurationComponent, {
      //panelClass: ".form-modal-interlocutor",
      data: {},
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result=='success') {
        this.findAllWithCount();
      }
    });
  }

  openSyncDialog(syncData: MiddlewareServiceAttributes): void {
    this.dialog
      .open(this.syncDialog, { data: syncData, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.onSincronize(syncData));
  }

  onSincronize(element: any){
    this.systemservicesService.sincronize(element.code).subscribe({
      next: (res:any) => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
        this.findAllWithCount();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
      }
    })
  }  

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}